import { useQuery } from 'react-query';
import experimentApi from '@experiment-management-shared/api/experimentApi';
import isEqual from 'lodash/isEqual';

const getExperimentPanelsAvailability = async experimentKeys => {
  const { data } = await experimentApi.fetchExperimentPanelsAvailability(
    experimentKeys
  );

  return data?.data;
};

const useExperimentPanelsAvailability = ({ experimentKeys }) => {
  return useQuery(
    ['experimentPanelsAvailability', ...experimentKeys],
    () => getExperimentPanelsAvailability(experimentKeys),
    {
      enabled: !!experimentKeys || experimentKeys.length === 0,
      refetchInterval: 30000,
      retry: false,
      structuralSharing: (oldData, newData) =>
        isEqual(oldData, newData) ? oldData : newData
    }
  );
};

export default useExperimentPanelsAvailability;
